export const data = {
  name: "Mr Developer",
  avatar:
    "https://clipartstation.com/wp-content/uploads/2017/11/software-developer-clipart-5.jpg",
  lastChat: "I created stensils !!!",
  lastSeen: "12:30 PM"
};

export const schema = {
  name: 12,
  lastChat: 65,
  lastSeen: 10
};
